var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoilInputLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.0562,
    cy: 23.2522,
    r: 22.5,
    fill: "#08A98A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.477 10.3976C21.8737 11.3092 13.25 16.059 13.25 16.059V21.3939L22.9725 26.7909V39.7834H25.6561L25.6557 25.2488L15.7678 19.7593V17.4997L23.4764 13.239C31.6696 17.7762 32.5907 18.2965 32.5907 18.2965V15.4585C28.7746 13.3716 23.477 10.3976 23.477 10.3976Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7451 18.6364L30.0713 23.8332V28.4203L28.4452 29.3213V32.4094L32.5892 30.1149V22.187C29.3532 20.3931 23.4705 17.1227 23.4705 17.1227L20.7451 18.6364Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 28.578L20.1627 32.4093V29.3212L13.25 25.4882V28.578Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoilInputLogo);
export default __webpack_public_path__ + "static/media/soilInputLogo.a2632efefe32b686e287ca6f4ee0bbc0.svg";
export { ForwardRef as ReactComponent };